/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_WorksInputs */

const en_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How It Works`)
};

const ar_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف يعمل`)
};

const de_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert es`)
};

const es_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const fr_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ça marche`)
};

const it_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona`)
};

const ja_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕組み`)
};

const ko_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용 방법`)
};

const pt_br_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona`)
};

const ru_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как это работает`)
};

const th_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีการทำงาน`)
};

const tr_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl çalışır`)
};

const zh_cn_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流程说明`)
};

const zh_tw_how_it_works = /** @type {(inputs: How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流程說明`)
};

/**
* | output |
* | --- |
* | "How It Works" |
*
* @param {How_It_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_it_works = /** @type {((inputs?: How_It_WorksInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_WorksInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_it_works(inputs)
	if (locale === "ar") return ar_how_it_works(inputs)
	if (locale === "de") return de_how_it_works(inputs)
	if (locale === "es") return es_how_it_works(inputs)
	if (locale === "fr") return fr_how_it_works(inputs)
	if (locale === "it") return it_how_it_works(inputs)
	if (locale === "ja") return ja_how_it_works(inputs)
	if (locale === "ko") return ko_how_it_works(inputs)
	if (locale === "pt_br") return pt_br_how_it_works(inputs)
	if (locale === "ru") return ru_how_it_works(inputs)
	if (locale === "th") return th_how_it_works(inputs)
	if (locale === "tr") return tr_how_it_works(inputs)
	if (locale === "zh_cn") return zh_cn_how_it_works(inputs)
	return zh_tw_how_it_works(inputs)
});